export default __webpack_public_path__ + "static/media/iconPolygonWhite.1e3fb4a1.svg";